<script setup lang="ts">
defineProps<{
  active?: boolean;
}>();
</script>

<template>
  <template v-if="!active">
    <svg xmlns="http://www.w3.org/2000/svg" id="Livello_1" data-name="Livello 1" viewBox="0 0 50 50" fill="currentColor">
      <path
        d="M11.12 33.22v.81h3.26v-3.26h-3.26v2.45Zm0 4.9h3.26v3.26h-3.26v-3.26Zm8.17-4.9v.81h3.26v-3.26h-3.26v2.45Zm0 4.9h3.26v3.26h-3.26v-3.26Zm8.16-4.9v.81h3.26v-3.26h-3.26v2.45Zm0 4.9h3.26v3.26h-3.26v-3.26Zm8.17-7.35h3.26v3.26h-3.26v-3.26Zm0 7.35h3.26v3.26h-3.26v-3.26Z"
      />
      <path d="M1.12 48.87V1.12h14.29v22.04L29.09 9.29h2.65v14.09L46 9.29h2.88v39.6H1.12Zm2.04-2.04h43.68V11.31L32.79 25.2h-3.1V11.56L16.24 25.2h-2.88V3.16H3.16v43.68Z" />
    </svg>
  </template>
  <template v-else>
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Livello 1" viewBox="0 0 50 50" fill="currentColor">
      <path
        d="M46 9.28 31.74 23.37V9.28h-2.65L15.41 23.15V1.12H1.12v47.76l47.77.01V9.28h-2.88ZM14.83 41.83h-4.15v-4.15h4.15v4.15Zm0-7.36h-4.15v-4.15h4.15v4.15Zm8.16 7.36h-4.15v-4.15h4.15v4.15Zm0-7.36h-4.15v-4.15h4.15v4.15Zm8.17 7.36h-4.15v-4.15h4.15v4.15Zm0-7.36h-4.15v-4.15h4.15v4.15Zm8.16 7.36h-4.15v-4.15h4.15v4.15Zm0-7.36h-4.15v-4.15h4.15v4.15Z"
        style="stroke-width: 0"
      />
    </svg>
  </template>
</template>
